(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3714],{

/***/ 44407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67287);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Heading = function Heading(props) {
  var children = props.children,
      className = props.className;
  var Tag = props.tag;
  Tag = Tag || 'h2';
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Heading_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Heading), className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Tag, {
    className: classes,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Heading);

/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MerchantSite; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _molecules_PreparingMerchantSite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60719);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var MerchantSite = function MerchantSite(_ref) {
  var children = _ref.children,
      isUnPublished = _ref.isUnPublished,
      isMerchantInfoExist = _ref.isMerchantInfoExist,
      _ref$isProtected = _ref.isProtected,
      isProtected = _ref$isProtected === void 0 ? false : _ref$isProtected,
      protectedElement = _ref.protectedElement,
      merchantPublicId = _ref.merchantPublicId,
      logoImage = _ref.logoImage,
      isCoubicApp = _ref.isCoubicApp;
  if (isUnPublished && !isMerchantInfoExist) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_molecules_PreparingMerchantSite__WEBPACK_IMPORTED_MODULE_1__/* .PreparingMerchantSite */ .B, {
    isCoubicApp: isCoubicApp,
    logoImage: logoImage,
    merchantPublicId: merchantPublicId
  });
  if (isProtected) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: protectedElement
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: children
  });
};

/***/ }),

/***/ 84915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ COUBIC_ORIGIN; },
  "Z": function() { return /* binding */ layouts_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/utils/gtag.ts
var gtag = __webpack_require__(7788);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/utils/GTMUtils.tsx






var GTMContainer = function GTMContainer() {
  return (
    /*#__PURE__*/
    // NOTE: gtag.js に渡す data layer と区別するため、名称を gtmDataLayer とする
    _jsx(_Fragment, {
      children: Object.values(GTM_CONFIGS).map(function (config) {
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});\n      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;\n      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=".concat(config.auth, "&gtm_preview=").concat(config.preview, "&gtm_cookies_win=x';\n      f.parentNode.insertBefore(j,f);})(window,document,'script','gtmDataLayer','").concat(config.containerId, "');\n      ");
        return /*#__PURE__*/_jsx("script", {
          dangerouslySetInnerHTML: {
            __html: script
          }
        });
      })
    })
  );
};
var GTMConfig = function GTMConfig() {
  var script = "\n    window.gtmDataLayer = window.gtmDataLayer || [];\n    function gtag(){gtmDataLayer.push(arguments);}\n  ";
  return /*#__PURE__*/_jsx("script", {
    dangerouslySetInnerHTML: {
      __html: script
    }
  });
};
var GTMNoScript = function GTMNoScript() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.values(GTM_CONFIGS).map(function (config) {
      return /*#__PURE__*/_jsx("noscript", {
        children: /*#__PURE__*/_jsx("iframe", {
          src: "https://www.googletagmanager.com/ns.html?id=".concat(config.containerId, "&gtm_auth=").concat(config.auth, "&gtm_preview=").concat(config.preview, "&gtm_cookies_win=x"),
          height: 0,
          width: 0,
          style: {
            display: 'none',
            visibility: 'hidden'
          }
        })
      });
    })
  });
};
var GA4Tag = function GA4Tag(_ref) {
  var pageTitle = _ref.pageTitle,
      googleAnalyticsFourTrackingId = _ref.googleAnalyticsFourTrackingId;
  react.useEffect(function () {
    // NOTE: ページタイトルを戻り値のjsに埋め込む場合はエスケープが必要なため、グローバル定数に設定して直接読み込ませる
    window.ga4PageTitle = pageTitle;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "https://www.googletagmanager.com/gtag/js?id=".concat(googleAnalyticsFourTrackingId)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "google-analytics-four-container",
      children: "\n          window.dataLayer = window.dataLayer || [];\n          function ga4tag(){dataLayer.push(arguments);}\n          const ga4ConfigParams = {page_title:window.ga4PageTitle}\n\n          const href = window.location.href;\n          const url = new URL(href);\n\n          const clientId = url.searchParams.get(\"gaClientId\");\n          const sessionId = url.searchParams.get(\"gaSessionId\");\n          if (clientId) { ga4ConfigParams['client_id'] = clientId; }\n          if (sessionId) { ga4ConfigParams['session_id'] = sessionId; }\n\n          ga4tag('js', new Date());\n          ga4tag('config','".concat(googleAnalyticsFourTrackingId, "',ga4ConfigParams);\n        ")
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/layouts/MetaTags.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







// 環境ごとに変わるものだが、本番環境以外では重要ではないので定数で書いている
var COUBIC_ORIGIN = 'https://coubic.com';

var MetaTags = function MetaTags(initProps) {
  var defaultProps = {
    title: 'Coubic (クービック) | 人気サービスの検索・予約サイト',
    description: '月間250万人以上が利用する検索・予約サイト「クービック」では、フィットネスジム・ヨガ・ピラティス・リラクなど様々なサービスを簡単に予約できます。事業者様は無料でサービス情報を掲載できると共に、180以上の業種に対応した予約システムを7日間無料でご利用頂けます。',
    thumbnailUrl: 'https://d3jf92lm1e7l6.cloudfront.net/images/shared/merchant_categories/4/600x400.png',
    keywords: '予約, クービック',
    currentUrl: COUBIC_ORIGIN,
    noIndex: false,
    opgDisabled: false
  };

  var _defaultProps$initPro = _objectSpread(_objectSpread({}, defaultProps), initProps),
      title = _defaultProps$initPro.title,
      description = _defaultProps$initPro.description,
      thumbnailUrl = _defaultProps$initPro.thumbnailUrl,
      keywords = _defaultProps$initPro.keywords,
      currentUrl = _defaultProps$initPro.currentUrl,
      pagination = _defaultProps$initPro.pagination,
      noIndex = _defaultProps$initPro.noIndex,
      opgDisabled = _defaultProps$initPro.opgDisabled,
      googleAnalyticsFourTrackingId = _defaultProps$initPro.googleAnalyticsFourTrackingId,
      faviconImageUrl = _defaultProps$initPro.faviconImageUrl;

  var titleWithSuffix = "".concat(title).concat(title !== defaultProps.title ? ' | Coubic' : '');
  var canonicalUrl = currentUrl.replace(/\?page=1$/g, '').replace(/\/\?/g, '?').replace(/\/$/, '');
  var baseUrl = currentUrl.replace(/\?.*$/, '');
  var robotsContent = noIndex ? 'noindex, follow, noarchive' : 'noarchive';
  var escapedDescription = description === null || description === void 0 ? void 0 : description.replace(/\s+/g, '');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [googleAnalyticsFourTrackingId && /*#__PURE__*/(0,jsx_runtime.jsx)(GA4Tag, {
      googleAnalyticsFourTrackingId: googleAnalyticsFourTrackingId,
      pageTitle: titleWithSuffix
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: titleWithSuffix
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        content: robotsContent,
        name: "robots"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: keywords
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: escapedDescription
      }), !opgDisabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:site_name",
          content: titleWithSuffix
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:type",
          content: "website"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:description",
          content: escapedDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:image",
          content: thumbnailUrl
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:card",
          content: "summary"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:site",
          content: "@coubic"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:title",
          content: titleWithSuffix
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:description",
          content: escapedDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:image",
          content: thumbnailUrl
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        href: canonicalUrl,
        rel: "canonical"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "imae/x-icon",
        href: faviconImageUrl !== null && faviconImageUrl !== void 0 ? faviconImageUrl : '/static/favicon.ico'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "shortcut icon",
        href: faviconImageUrl !== null && faviconImageUrl !== void 0 ? faviconImageUrl : '/static/favicon.ico'
      }), pagination && pagination.currentPage < pagination.totalPages && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "next",
        href: "".concat(baseUrl, "?page=").concat(pagination.currentPage + 1)
      }), pagination && pagination.currentPage !== 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "prev",
        href: "".concat(baseUrl, "?page=").concat(pagination.currentPage - 1)
      })]
    })]
  });
};

/* harmony default export */ var layouts_MetaTags = (MetaTags);

/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useStaffBookingPageMapping; },
/* harmony export */   "k": function() { return /* binding */ useBookingCalendarMeta; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59734);
/* harmony import */ var _infrastructure_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31735);




var useBookingCalendarMeta = function useBookingCalendarMeta(merchantPublicId) {
  var swrKey = "/merchants/".concat(merchantPublicId, "/booking_calendar_meta");

  var fetcher = /*#__PURE__*/function () {
    var _ref = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var data;
      return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_infrastructure_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchBookingCalendarMeta */ .S_)(merchantPublicId);

            case 2:
              data = _context.sent;
              return _context.abrupt("return", data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetcher() {
      return _ref.apply(this, arguments);
    };
  }();

  var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(swrKey, fetcher),
      data = _useSWR.data,
      error = _useSWR.error,
      isValidating = _useSWR.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
};
var useStaffBookingPageMapping = function useStaffBookingPageMapping(merchantPublicId, option) {
  var _useBookingCalendarMe = useBookingCalendarMeta(merchantPublicId),
      data = _useBookingCalendarMe.data;

  var bookingPages = data === null || data === void 0 ? void 0 : data.booking_pages;
  var targetBookingPageIds = option === null || option === void 0 ? void 0 : option.bookingPageIds; // key: staff_canonical_id, value: booking_page ids

  var staffBookingPageIdsMap = {};
  var staffMembers = [];
  var targetBookingPages = targetBookingPageIds ? bookingPages === null || bookingPages === void 0 ? void 0 : bookingPages.filter(function (bookingPage) {
    return targetBookingPageIds.includes(bookingPage.public_id);
  }) : bookingPages;
  targetBookingPages === null || targetBookingPages === void 0 ? void 0 : targetBookingPages.forEach(function (bookingPage) {
    bookingPage.assigned_staff_members.forEach(function (staff) {
      if (staffBookingPageIdsMap[staff.canonical_id]) {
        staffBookingPageIdsMap[staff.canonical_id].push(bookingPage.public_id);
      } else {
        staffMembers.push({
          name: staff.name,
          canonical_id: staff.canonical_id,
          sort_order: staff.sort_order,
          updated_at: staff.updated_at
        });
        staffBookingPageIdsMap[staff.canonical_id] = [bookingPage.public_id];
      }
    });
  }); // 並び順の関心を持ちすぎているが、暫定対応

  var sortedByOrderStaffMembers = staffMembers.sort(function (a, b) {
    if (a.sort_order < b.sort_order) {
      return -1;
    }

    if (a.sort_order > b.sort_order) {
      return 1;
    }

    return 0;
  });
  var result = sortedByOrderStaffMembers.sort(function (a, b) {
    if (a.updated_at > b.updated_at) {
      return 1;
    }

    return 0;
  });
  return {
    staffBookingPageIdsMap: staffBookingPageIdsMap,
    staffMembers: result,
    bookingPages: bookingPages !== null && bookingPages !== void 0 ? bookingPages : []
  };
};

/***/ }),

/***/ 87030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tg": function() { return /* binding */ useAvailableFirstTimeFreeCoupon; },
  "mu": function() { return /* binding */ useCouponBookingPageIds; },
  "dg": function() { return /* binding */ useMerchantCoupons; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(59734);
// EXTERNAL MODULE: ./src/redux/actions/merchants/resources/books/api.ts + 1 modules
var api = __webpack_require__(85566);
// EXTERNAL MODULE: ./src/redux/selectors/merchants/resources/books/inputs.ts
var books_inputs = __webpack_require__(41189);
// EXTERNAL MODULE: ./src/hooks/redux.ts
var redux = __webpack_require__(14618);
// EXTERNAL MODULE: ./src/hooks/api/booking-calendar-meta/index.ts
var booking_calendar_meta = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/utils/apiroot.ts
var apiroot = __webpack_require__(36057);
// EXTERNAL MODULE: ./src/utils/secured-axios.ts
var secured_axios = __webpack_require__(25363);
;// CONCATENATED MODULE: ./src/infrastructure/api/coupon/index.ts




// clientでは使われていないのでSSR用のみを用意
var fetchCouponDetailForSSR = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var session, token, requestId, merchantPublicId, couponPublicId, client, path, _yield$client$get, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            session = _ref.session, token = _ref.token, requestId = _ref.requestId, merchantPublicId = _ref.merchantPublicId, couponPublicId = _ref.couponPublicId;
            client = newSecuredAxios({
              session: session,
              token: token,
              requestId: requestId
            });
            _context.prev = 2;
            path = "".concat(apiRoot(), "/merchants/").concat(merchantPublicId, "/vouchers/").concat(couponPublicId);
            _context.next = 6;
            return client.get(path);

          case 6:
            _yield$client$get = _context.sent;
            data = _yield$client$get.data;
            return _context.abrupt("return", data);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function fetchCouponDetailForSSR(_x) {
    return _ref2.apply(this, arguments);
  };
}()));
var fetchMerchantCoupons = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(merchantPublicId) {
    var path, _yield$securedAxios$g, data;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = "".concat((0,apiroot/* apiRoot */.b)(), "/merchants/").concat(merchantPublicId, "/vouchers");
            _context2.next = 3;
            return secured_axios/* default.get */.ZP.get(path);

          case 3:
            _yield$securedAxios$g = _context2.sent;
            data = _yield$securedAxios$g.data;
            return _context2.abrupt("return", data.vouchers);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchMerchantCoupons(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var fetchMerchantCouponsForSSR = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var session, token, requestId, merchantPublicId, client, path, _yield$client$get2, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            session = _ref4.session, token = _ref4.token, requestId = _ref4.requestId, merchantPublicId = _ref4.merchantPublicId;
            client = newSecuredAxios({
              session: session,
              token: token,
              requestId: requestId
            });
            _context3.prev = 2;
            path = "".concat(apiRoot(), "/merchants/").concat(merchantPublicId, "/vouchers");
            _context3.next = 6;
            return client.get(path);

          case 6:
            _yield$client$get2 = _context3.sent;
            data = _yield$client$get2.data;
            return _context3.abrupt("return", data.vouchers);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](2);
            throw _context3.t0;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 11]]);
  }));

  return function fetchMerchantCouponsForSSR(_x3) {
    return _ref5.apply(this, arguments);
  };
}()));
;// CONCATENATED MODULE: ./src/hooks/api/coupon/index.ts









var useMerchantCoupons = function useMerchantCoupons(params) {
  var merchantPublicId = params.merchantPublicId;
  var swrKey = "/merchants/".concat(merchantPublicId, "/vouchers");

  var fetcher = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var data;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchMerchantCoupons(merchantPublicId);

            case 2:
              data = _context.sent;
              return _context.abrupt("return", data);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetcher() {
      return _ref.apply(this, arguments);
    };
  }();

  var _useSWR = (0,dist/* default */.ZP)(swrKey, fetcher),
      data = _useSWR.data,
      error = _useSWR.error,
      isValidating = _useSWR.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
};

var useCouponBookingPageMapping = function useCouponBookingPageMapping(merchantPublicId) {
  var _useBookingCalendarMe = (0,booking_calendar_meta/* useBookingCalendarMeta */.k)(merchantPublicId),
      data = _useBookingCalendarMe.data;

  return (0,react.useMemo)(function () {
    // key: coupon  public_id, value: booking_page ids
    var couponBookingPageIdsMap = {};
    var coupons = [];
    data === null || data === void 0 ? void 0 : data.booking_pages.forEach(function (bookingPage) {
      bookingPage.assigned_vouchers.forEach(function (voucher) {
        if (couponBookingPageIdsMap[voucher.public_id]) {
          couponBookingPageIdsMap[voucher.public_id].push(bookingPage.public_id);
        } else {
          coupons.push({
            name: voucher.name,
            publicId: voucher.public_id
          });
          couponBookingPageIdsMap[voucher.public_id] = [bookingPage.public_id];
        }
      });
    });
    return {
      couponBookingPageIdsMap: couponBookingPageIdsMap,
      coupons: coupons
    };
  }, [data]);
};

var useCouponBookingPageIds = function useCouponBookingPageIds(params) {
  var merchantPublicId = params.merchantPublicId,
      couponPublicId = params.couponPublicId;

  var _useCouponBookingPage = useCouponBookingPageMapping(merchantPublicId),
      couponBookingPageIdsMap = _useCouponBookingPage.couponBookingPageIdsMap;

  return couponBookingPageIdsMap[couponPublicId];
};
var useAvailableFirstTimeFreeCoupon = function useAvailableFirstTimeFreeCoupon() {
  var _useShallowEqualSelec = (0,redux/* useShallowEqualSelector */.M)(function (state) {
    return {
      inputs: (0,books_inputs/* getMerchantResourcesBooksInputs */.A)(state.merchantsResourcesBooksInputs)
    };
  }),
      inputs = _useShallowEqualSelec.inputs;

  var swrKey = inputs.reservationId ? "/reservations/".concat(inputs.reservationId, "/payment_methods") : null;

  var fetcher = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _inputs$merchantId, _inputs$reservationId;

      var data, firstTimeFreeCouponPaymentMethod, couponInfo;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,api/* fetchReservationPaymentMethods */.qK)((_inputs$merchantId = inputs.merchantId) !== null && _inputs$merchantId !== void 0 ? _inputs$merchantId : '', (_inputs$reservationId = inputs.reservationId) !== null && _inputs$reservationId !== void 0 ? _inputs$reservationId : 0);

            case 2:
              data = _context2.sent;
              firstTimeFreeCouponPaymentMethod = data.payment_methods.find(function (method) {
                return method.method === 'first_time_free_voucher';
              });
              couponInfo = (firstTimeFreeCouponPaymentMethod === null || firstTimeFreeCouponPaymentMethod === void 0 ? void 0 : firstTimeFreeCouponPaymentMethod.products.length) !== 0 ? firstTimeFreeCouponPaymentMethod === null || firstTimeFreeCouponPaymentMethod === void 0 ? void 0 : firstTimeFreeCouponPaymentMethod.products[0] : undefined;
              return _context2.abrupt("return", couponInfo ? {
                publicId: couponInfo.public_id,
                name: couponInfo.name,
                paymentMethod: firstTimeFreeCouponPaymentMethod
              } : undefined);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetcher() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useSWR2 = (0,dist/* default */.ZP)(swrKey, fetcher),
      data = _useSWR2.data,
      error = _useSWR2.error,
      isValidating = _useSWR2.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
};

/***/ }),

/***/ 14618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useShallowEqualSelector; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66338);

var useShallowEqualSelector = function useShallowEqualSelector(selector) {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(selector, react_redux__WEBPACK_IMPORTED_MODULE_0__/* .shallowEqual */ .wU);
};

/***/ }),

/***/ 85566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ug": function() { return /* binding */ addToWaitingList; },
  "fm": function() { return /* binding */ fetchAvailableDates; },
  "kp": function() { return /* binding */ fetchAvailableTimes; },
  "vx": function() { return /* binding */ fetchConfirmation; },
  "uH": function() { return /* binding */ fetchCourse; },
  "dq": function() { return /* binding */ fetchCustomFields; },
  "eZ": function() { return /* binding */ fetchEvent; },
  "sZ": function() { return /* binding */ fetchEvents; },
  "u6": function() { return /* binding */ fetchLesson; },
  "qK": function() { return /* binding */ fetchReservationPaymentMethods; },
  "PG": function() { return /* binding */ fetchResource; },
  "tg": function() { return /* binding */ fetchSelectedCourse; },
  "vU": function() { return /* binding */ fetchSelectedStaff; },
  "Kl": function() { return /* binding */ fetchSelectedTimeSlot; },
  "dQ": function() { return /* binding */ fetchStaff; },
  "HA": function() { return /* binding */ fetchTimeSlots; },
  "t9": function() { return /* binding */ postPayment; },
  "iz": function() { return /* binding */ postReservationsBookingDateTime; },
  "V8": function() { return /* binding */ postReservationsFinish; },
  "Tp": function() { return /* binding */ postReservationsPayment; },
  "C3": function() { return /* binding */ postReservationsStart; },
  "WK": function() { return /* binding */ postReservationsTimeSlots; },
  "Ub": function() { return /* binding */ postReservationsUserInfo; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__(47292);
// EXTERNAL MODULE: ./src/infrastructure/api/index.ts + 2 modules
var api = __webpack_require__(31735);
// EXTERNAL MODULE: ./src/utils/secured-axios.ts
var secured_axios = __webpack_require__(25363);
// EXTERNAL MODULE: ./src/interfaces/merchants/resources/books/index.ts
var books = __webpack_require__(40043);
;// CONCATENATED MODULE: ./src/redux/actions/merchants/resources/books/apiBodyBuilder.ts
var toQuestionnaireValue = function toQuestionnaireValue(value) {
  return typeof value === 'string' ? value : Object.keys(value).filter(function (k) {
    return value[k];
  });
};

var isArrayOfString = function isArrayOfString(value) {
  return Array.isArray(value) ? value.every(function (item) {
    return typeof item === 'string';
  }) : false;
};

var toQuestionnaireAttributes = function toQuestionnaireAttributes(id, value) {
  if (isArrayOfString(value)) {
    if (value.length !== 0) {
      return {
        questionnaire_custom_field_id: id,
        value: value,
        value_type: 'array_type'
      };
    } else {
      return undefined;
    }
  } else {
    return value ? {
      questionnaire_custom_field_id: id,
      value: value
    } : undefined;
  }
};
var withEventTimeSlot = function withEventTimeSlot(eventTimeSlot) {
  return {
    time_slot_ids: eventTimeSlot.timeSlots.map(function (t) {
      return t.id.toString();
    }),
    num_attendees: eventTimeSlot.attendees
  };
};
var withTimeSlotAvailability = function withTimeSlotAvailability(timeSlotAvailability) {
  var date = timeSlotAvailability.date,
      value = timeSlotAvailability.value;
  return {
    preferred_date: date,
    preferred_time: value
  };
};
var withSchoolTimeSlot = function withSchoolTimeSlot(schoolTimeSlots) {
  return {
    time_slot_ids: schoolTimeSlots.map(function (t) {
      return t.id.toString();
    })
  };
};
var withUserInfo = function withUserInfo(userInfo) {
  var struct = {};
  var customerFields = userInfo.customerFields,
      surveyAnswer = userInfo.surveyAnswer,
      questionnaires = userInfo.questionnaires;
  var contact = {};

  if (customerFields) {
    Object.keys(customerFields).forEach(function (k) {
      contact[k] = customerFields[k];
    });
  }

  struct.contact = contact;

  if (surveyAnswer) {
    struct.survey_answer = surveyAnswer;
  }

  if (questionnaires) {
    struct.questionnaires_attributes = [];
    Object.keys(questionnaires).forEach(function (id) {
      var item = toQuestionnaireAttributes(id, toQuestionnaireValue(questionnaires[id]));

      if (item) {
        var _struct$questionnaire;

        (_struct$questionnaire = struct.questionnaires_attributes) === null || _struct$questionnaire === void 0 ? void 0 : _struct$questionnaire.push(item);
      }
    });
  }

  return struct;
};

var toPaymentMethod = function toPaymentMethod(payment, options) {
  var email = options.email,
      _final = options["final"];

  if (payment.paymentMethod.method === 'onsite') {
    return {
      method: 'onsite'
    };
  }

  if (payment.paymentMethod.method === 'bank_transfer') {
    return {
      method: 'bank_transfer'
    };
  }

  if (payment.paymentMethod.method === 'subscription') {
    return {
      method: 'subscription',
      customer_subscription_id: payment.subscriptionSelection
    };
  }

  if (payment.paymentMethod.method === 'ticket') {
    return {
      method: 'ticket',
      product_id: payment.ticketSelection
    };
  }

  if (payment.paymentMethod.method === 'first_time_free_voucher') {
    var _payment$firstTimeFre;

    return {
      method: 'first_time_free_voucher',
      voucher_public_id: (_payment$firstTimeFre = payment.firstTimeFreeCouponPublicId) !== null && _payment$firstTimeFre !== void 0 ? _payment$firstTimeFre : '',
      email: email
    };
  }

  if (!payment.cardSelection) {
    // カード選びがない => 利用歴がなく新しいカード生成
    return {
      ctok: _final ? payment.token : '',
      method: 'credit_card'
    };
  }

  if (payment.cardSelection === 'another') {
    // カード利用歴があるが、新しく生成する
    return {
      ctok: _final ? payment.token : '',
      method: 'credit_card',
      restore_credit_card: false
    };
  }

  if (payment.cardSelection === 'used') {
    // カード利用歴があり、以前のカードを利用する
    return {
      method: 'credit_card',
      restore_credit_card: true
    };
  }

  throw new Error("cannot create payment: payment ".concat(payment));
};

var withPayment = function withPayment(payment, options) {
  return {
    payment_method: toPaymentMethod(payment, {
      "final": false,
      email: options.email
    })
  };
};
var withFinalize = function withFinalize(termsAccepted, selectedPaymentMethod) {
  return {
    terms_accepted: termsAccepted,
    payment_method: selectedPaymentMethod
  };
};
// EXTERNAL MODULE: ./src/utils/stripe.ts
var stripe = __webpack_require__(26246);
;// CONCATENATED MODULE: ./src/redux/actions/merchants/resources/books/api.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










/** @deprecated SSRでのリクエスト時にセッション情報がのらない */
var fetchResource = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(merchantId, resourceId) {
    var _yield$securedAxios$g, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "?formatted=true"));

          case 2:
            _yield$securedAxios$g = _context.sent;
            data = _yield$securedAxios$g.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchResource(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/** @deprecated SSRでのリクエスト時にセッション情報がのらない */

var fetchCourse = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(merchantId, resourceId) {
    var _yield$securedAxios$g2, data;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/courses"));

          case 2:
            _yield$securedAxios$g2 = _context2.sent;
            data = _yield$securedAxios$g2.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCourse(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchSelectedCourse = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(merchantId, resourceId, CourseId) {
    var _yield$securedAxios$g3, data;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/courses/").concat(CourseId));

          case 3:
            _yield$securedAxios$g3 = _context3.sent;
            data = _yield$securedAxios$g3.data;
            return _context3.abrupt("return", data);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);

            if (!(axios_default().isAxiosError(_context3.t0) && _context3.t0.response && _context3.t0.response.status < 500)) {
              _context3.next = 12;
              break;
            }

            return _context3.abrupt("return");

          case 12:
            throw _context3.t0;

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function fetchSelectedCourse(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
/** @deprecated SSRでのリクエスト時にセッション情報がのらない */

var fetchLesson = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(merchantId, resourceId) {
    var _yield$securedAxios$g4, data;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/lessons"));

          case 2:
            _yield$securedAxios$g4 = _context4.sent;
            data = _yield$securedAxios$g4.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchLesson(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
/** @deprecated SSRでのリクエスト時にセッション情報がのらない */

var fetchStaff = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(merchantId, resourceId) {
    var _yield$securedAxios$g5, data;

    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/staff"));

          case 2:
            _yield$securedAxios$g5 = _context5.sent;
            data = _yield$securedAxios$g5.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchStaff(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();
var fetchSelectedStaff = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(merchantId, resourceId, staffId) {
    var _yield$securedAxios$g6, data;

    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/staff/").concat(staffId));

          case 3:
            _yield$securedAxios$g6 = _context6.sent;
            data = _yield$securedAxios$g6.data;
            return _context6.abrupt("return", data);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);

            if (!(axios_default().isAxiosError(_context6.t0) && _context6.t0.response && _context6.t0.response.status < 500)) {
              _context6.next = 12;
              break;
            }

            return _context6.abrupt("return");

          case 12:
            throw _context6.t0;

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function fetchSelectedStaff(_x12, _x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();
var FORMAT = 'YYYYMMDDHHmm'; // 201811252001 2018/11/25 20:01

var toCalendarParam = function toCalendarParam(q) {
  var query = new URLSearchParams({
    course_id: q.course.id.toString(),
    start: date_fns.format(q.start, FORMAT),
    end: date_fns.format(q.end, FORMAT)
  });
  q.options.map(function (o) {
    return query.append('option_ids[]', o.id.toString());
  });
  if (q.staff) query.append('staff_id', q.staff.id.toString());
  return query.toString();
};

var fetchEvents = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(q) {
    var url, _yield$securedAxios$g7, data;

    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = new URL("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(q.merchantId, "/booking_pages/").concat(q.resourceId, "/events"));
            url.search = toCalendarParam(q);
            _context7.next = 4;
            return secured_axios/* default.get */.ZP.get(url.toString());

          case 4:
            _yield$securedAxios$g7 = _context7.sent;
            data = _yield$securedAxios$g7.data;
            return _context7.abrupt("return", data);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function fetchEvents(_x15) {
    return _ref7.apply(this, arguments);
  };
}();

var toDatePickerParam = function toDatePickerParam(q) {
  var query = new URLSearchParams();
  if (!!q.lesson) query.append('lesson_id', q.lesson.id.toString());
  if (!!q.start) query.append('start', date_fns.format(q.start, FORMAT));
  if (!!q.end) query.append('end', date_fns.format(q.end, FORMAT));
  return query.toString();
};

var fetchTimeSlots = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(q) {
    var url, _yield$securedAxios$g8, data;

    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            url = new URL("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(q.merchantId, "/booking_pages/").concat(q.resourceId, "/time_slots"));
            url.search = toDatePickerParam(q);
            _context8.next = 5;
            return secured_axios/* default.get */.ZP.get(url.toString());

          case 5:
            _yield$securedAxios$g8 = _context8.sent;
            data = _yield$securedAxios$g8.data;
            return _context8.abrupt("return", data);

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", {
              meta: {
                staff: undefined,
                waiting_list_provided: false,
                waiting_listed: []
              },
              data: []
            });

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 10]]);
  }));

  return function fetchTimeSlots(_x16) {
    return _ref8.apply(this, arguments);
  };
}();

var toAvailableDateTimeParam = function toAvailableDateTimeParam(q) {
  var query = new URLSearchParams({
    course_id: q.course.id.toString(),
    date: date_fns.format(q.date, FORMAT)
  });
  q.options.map(function (o) {
    return query.append('option_ids[]', o.id.toString());
  });
  if (q.staff) query.append('staff_id', q.staff.id.toString());
  return query.toString();
};

var fetchAvailableDates = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(q) {
    var url, _yield$securedAxios$g9, data;

    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = new URL("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(q.merchantId, "/booking_pages/").concat(q.resourceId, "/available_dates"));
            url.search = toAvailableDateTimeParam(q);
            _context9.next = 4;
            return secured_axios/* default.get */.ZP.get(url.toString());

          case 4:
            _yield$securedAxios$g9 = _context9.sent;
            data = _yield$securedAxios$g9.data;
            return _context9.abrupt("return", data);

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function fetchAvailableDates(_x17) {
    return _ref9.apply(this, arguments);
  };
}();
var fetchAvailableTimes = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(q) {
    var url, _yield$securedAxios$g10, data;

    return regenerator_default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            url = new URL("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(q.merchantId, "/booking_pages/").concat(q.resourceId, "/available_times"));
            url.search = toAvailableDateTimeParam(q);
            _context10.next = 4;
            return secured_axios/* default.get */.ZP.get(url.toString());

          case 4:
            _yield$securedAxios$g10 = _context10.sent;
            data = _yield$securedAxios$g10.data;
            return _context10.abrupt("return", data);

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function fetchAvailableTimes(_x18) {
    return _ref10.apply(this, arguments);
  };
}();
var addToWaitingList = /*#__PURE__*/function () {
  var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11(merchantPublicId, resourceId, timeSlot, lastName, firstName, email) {
    var client, _yield$client$post, data;

    return regenerator_default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            client = (0,secured_axios/* newSecuredAxios */._R)({
              merchantPublicId: merchantPublicId
            });
            _context11.next = 4;
            return client.post("".concat((0,api/* apiRoot */.bI)(), "/reservations/waiting_list"), {
              resource_id: resourceId,
              time_slot_id: timeSlot.id,
              last_name: lastName,
              first_name: firstName,
              email: email
            });

          case 4:
            _yield$client$post = _context11.sent;
            data = _yield$client$post.data;
            return _context11.abrupt("return", data);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](0);

            if (!(axios_default().isAxiosError(_context11.t0) && _context11.t0.response && _context11.t0.response.status === 400)) {
              _context11.next = 13;
              break;
            }

            return _context11.abrupt("return", _context11.t0.response.data);

          case 13:
            return _context11.abrupt("return", {
              success: false
            });

          case 14:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 9]]);
  }));

  return function addToWaitingList(_x19, _x20, _x21, _x22, _x23, _x24) {
    return _ref11.apply(this, arguments);
  };
}();
var fetchCustomFields = /*#__PURE__*/function () {
  var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(merchantId, resourceId) {
    var _yield$securedAxios$g11, data;

    return regenerator_default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/custom_fields"));

          case 2:
            _yield$securedAxios$g11 = _context12.sent;
            data = _yield$securedAxios$g11.data;
            return _context12.abrupt("return", data);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function fetchCustomFields(_x25, _x26) {
    return _ref12.apply(this, arguments);
  };
}();
var fetchConfirmation = /*#__PURE__*/function () {
  var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee13(merchantId, resourceId) {
    var _yield$securedAxios$g12, data;

    return regenerator_default().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/confirm"));

          case 2:
            _yield$securedAxios$g12 = _context13.sent;
            data = _yield$securedAxios$g12.data;
            return _context13.abrupt("return", data);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function fetchConfirmation(_x27, _x28) {
    return _ref13.apply(this, arguments);
  };
}();
var fetchEvent = /*#__PURE__*/function () {
  var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee14(merchantId, resourceId) {
    var _yield$securedAxios$g13, data;

    return regenerator_default().wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/event"));

          case 2:
            _yield$securedAxios$g13 = _context14.sent;
            data = _yield$securedAxios$g13.data;
            return _context14.abrupt("return", data);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function fetchEvent(_x29, _x30) {
    return _ref14.apply(this, arguments);
  };
}();
var fetchSelectedTimeSlot = /*#__PURE__*/function () {
  var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee15(merchantId, resourceId, timeSlotId) {
    var _yield$securedAxios$g14, data;

    return regenerator_default().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return secured_axios/* default.get */.ZP.get("".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(merchantId, "/booking_pages/").concat(resourceId, "/time_slots/").concat(timeSlotId));

          case 3:
            _yield$securedAxios$g14 = _context15.sent;
            data = _yield$securedAxios$g14.data;
            return _context15.abrupt("return", data);

          case 8:
            _context15.prev = 8;
            _context15.t0 = _context15["catch"](0);

            if (!(axios_default().isAxiosError(_context15.t0) && _context15.t0.response && _context15.t0.response.status < 500)) {
              _context15.next = 12;
              break;
            }

            return _context15.abrupt("return");

          case 12:
            throw _context15.t0;

          case 13:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 8]]);
  }));

  return function fetchSelectedTimeSlot(_x31, _x32, _x33) {
    return _ref15.apply(this, arguments);
  };
}();
var fetchReservationPaymentMethods = /*#__PURE__*/function () {
  var _ref16 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee16(merchantPublicId, reservationId) {
    var client, _yield$client$get, data;

    return regenerator_default().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            client = (0,secured_axios/* newSecuredAxios */._R)({
              merchantPublicId: merchantPublicId
            });
            _context16.next = 3;
            return client.get("".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/payment_methods"));

          case 3:
            _yield$client$get = _context16.sent;
            data = _yield$client$get.data;
            return _context16.abrupt("return", data);

          case 6:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function fetchReservationPaymentMethods(_x34, _x35) {
    return _ref16.apply(this, arguments);
  };
}();

var inputsToPostStructure = function inputsToPostStructure(inputs, options) {
  if (inputs.course) {
    return inputs.staff ? {
      course_id: inputs.course.id.toString(),
      option_ids: inputs.options.map(function (o) {
        return o.id.toString();
      }),
      staff_id: inputs.staff.id.toString()
    } : inputs.options ? {
      course_id: inputs.course.id.toString(),
      option_ids: inputs.options.map(function (o) {
        return o.id.toString();
      })
    } : {
      course_id: inputs.course.id.toString()
    };
  }

  if (inputs.lesson) {
    return {
      lesson_id: inputs.lesson.id.toString()
    };
  }

  if (inputs.eventTimeSlot) {
    return withEventTimeSlot(inputs.eventTimeSlot);
  }

  if (inputs.timeSlotAvailability) {
    return withTimeSlotAvailability(inputs.timeSlotAvailability);
  }

  if (inputs.schoolTimeSlots) {
    return withSchoolTimeSlot(inputs.schoolTimeSlots);
  }

  if (inputs.userInfo) {
    return withUserInfo(inputs.userInfo);
  }

  if (inputs.payment) {
    var _options$email;

    return withPayment(inputs.payment, {
      email: (_options$email = options === null || options === void 0 ? void 0 : options.email) !== null && _options$email !== void 0 ? _options$email : ''
    });
  }

  if (inputs.termsAccepted || inputs.selectedPaymentMethod) {
    return withFinalize(inputs.termsAccepted, inputs.selectedPaymentMethod);
  }

  return {};
};

var bookingFirstStepUrl = function bookingFirstStepUrl(modelType, reservationId) {
  if (modelType === books/* ModelType.EventScheme */.BY.EventScheme) {
    return "".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/time_slots");
  } else if (modelType === books/* ModelType.SchoolScheme */.BY.SchoolScheme) {
    return "".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/lesson");
  } else {
    return "".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/course");
  }
};

var _postReservations = /*#__PURE__*/function () {
  var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee17(url, reqData, merchantPublicId) {
    var client, _yield$client$post2, data;

    return regenerator_default().wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            client = (0,secured_axios/* newSecuredAxios */._R)({
              merchantPublicId: merchantPublicId
            });
            _context17.next = 4;
            return client.post(url, reqData);

          case 4:
            _yield$client$post2 = _context17.sent;
            data = _yield$client$post2.data;
            return _context17.abrupt("return", data);

          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](0);

            if (!(axios_default().isAxiosError(_context17.t0) && _context17.t0.response)) {
              _context17.next = 17;
              break;
            }

            if (!(_context17.t0.response.status === 400)) {
              _context17.next = 16;
              break;
            }

            return _context17.abrupt("return", _objectSpread(_objectSpread({}, _context17.t0.response.data), {}, {
              errorCode: _context17.t0.response.status
            }));

          case 16:
            return _context17.abrupt("return", {
              success: false,
              errorCode: _context17.t0.response.status
            });

          case 17:
            throw _context17.t0;

          case 18:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 9]]);
  }));

  return function _postReservations(_x36, _x37, _x38) {
    return _ref17.apply(this, arguments);
  };
}();

var postReservationsStart = /*#__PURE__*/function () {
  var _ref18 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee18(modelType, merchantId, resourceId, inputs, withExpressFlow, reservationId) {
    return regenerator_default().wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (!reservationId) {
              _context18.next = 12;
              break;
            }

            _context18.t1 = _postReservations;
            _context18.t2 = bookingFirstStepUrl(modelType, reservationId.toString());
            _context18.next = 5;
            return inputsToPostStructure(inputs);

          case 5:
            _context18.t3 = _context18.sent;
            _context18.t4 = merchantId;
            _context18.t5 = {
              input: _context18.t3,
              public_id: _context18.t4
            };
            _context18.t6 = merchantId;
            _context18.t0 = (0, _context18.t1)(_context18.t2, _context18.t5, _context18.t6);
            _context18.next = 23;
            break;

          case 12:
            _context18.t7 = _postReservations;
            _context18.t8 = "".concat((0,api/* apiRoot */.bI)(), "/reservations");
            _context18.next = 16;
            return inputsToPostStructure(inputs);

          case 16:
            _context18.t9 = _context18.sent;
            _context18.t10 = merchantId;
            _context18.t11 = resourceId;
            _context18.t12 = withExpressFlow ? 'express' : '';
            _context18.t13 = {
              input: _context18.t9,
              public_id: _context18.t10,
              resource_id: _context18.t11,
              booked_from: _context18.t12
            };
            _context18.t14 = merchantId;
            _context18.t0 = (0, _context18.t7)(_context18.t8, _context18.t13, _context18.t14);

          case 23:
            return _context18.abrupt("return", _context18.t0);

          case 24:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function postReservationsStart(_x39, _x40, _x41, _x42, _x43, _x44) {
    return _ref18.apply(this, arguments);
  };
}();
var postReservationsBookingDateTime = /*#__PURE__*/function () {
  var _ref19 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee19(reservationId, inputs, merchantPublicId) {
    return regenerator_default().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.t0 = _postReservations;
            _context19.t1 = "".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/preferred_datetime");
            _context19.next = 4;
            return inputsToPostStructure(inputs);

          case 4:
            _context19.t2 = _context19.sent;
            _context19.t3 = {
              input: _context19.t2
            };
            _context19.t4 = merchantPublicId;
            return _context19.abrupt("return", (0, _context19.t0)(_context19.t1, _context19.t3, _context19.t4));

          case 8:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function postReservationsBookingDateTime(_x45, _x46, _x47) {
    return _ref19.apply(this, arguments);
  };
}();
var postReservationsTimeSlots = /*#__PURE__*/function () {
  var _ref20 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee20(reservationId, inputs, merchantPublicId) {
    return regenerator_default().wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.t0 = _postReservations;
            _context20.t1 = "".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/time_slots");
            _context20.next = 4;
            return inputsToPostStructure(inputs);

          case 4:
            _context20.t2 = _context20.sent;
            _context20.t3 = {
              input: _context20.t2
            };
            _context20.t4 = merchantPublicId;
            return _context20.abrupt("return", (0, _context20.t0)(_context20.t1, _context20.t3, _context20.t4));

          case 8:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function postReservationsTimeSlots(_x48, _x49, _x50) {
    return _ref20.apply(this, arguments);
  };
}();
var postReservationsUserInfo = /*#__PURE__*/function () {
  var _ref21 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee21(reservationId, inputs, merchantPublicId) {
    var requestBody, contact, _inputs$userInfo, customerFields, surveyAnswer, questionnaires, client, _yield$client$post3, data;

    return regenerator_default().wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            requestBody = {};
            contact = {};

            if (inputs.userInfo) {
              _inputs$userInfo = inputs.userInfo, customerFields = _inputs$userInfo.customerFields, surveyAnswer = _inputs$userInfo.surveyAnswer, questionnaires = _inputs$userInfo.questionnaires;

              if (customerFields) {
                Object.keys(customerFields).forEach(function (k) {
                  contact[k] = customerFields[k];
                });
              }

              requestBody.contact = contact;

              if (surveyAnswer) {
                requestBody.survey_answer = surveyAnswer;
              }

              if (questionnaires) {
                requestBody.questionnaires_attributes = [];
                Object.keys(questionnaires).forEach(function (id) {
                  var item = toQuestionnaireAttributes(id, toQuestionnaireValue(questionnaires[id]));

                  if (item) {
                    var _requestBody$question;

                    (_requestBody$question = requestBody.questionnaires_attributes) === null || _requestBody$question === void 0 ? void 0 : _requestBody$question.push(item);
                  }
                });
              }
            }

            _context21.prev = 3;
            client = (0,secured_axios/* newSecuredAxios */._R)({
              merchantPublicId: merchantPublicId
            });
            _context21.next = 7;
            return client.post("".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/customer"), {
              input: requestBody
            });

          case 7:
            _yield$client$post3 = _context21.sent;
            data = _yield$client$post3.data;
            return _context21.abrupt("return", {
              success: true,
              data: data,
              errorCode: 200
            });

          case 12:
            _context21.prev = 12;
            _context21.t0 = _context21["catch"](3);

            if (!(axios_default().isAxiosError(_context21.t0) && _context21.t0.response)) {
              _context21.next = 20;
              break;
            }

            if (!(_context21.t0.response.status === 400)) {
              _context21.next = 19;
              break;
            }

            return _context21.abrupt("return", _objectSpread(_objectSpread({}, _context21.t0.response.data), {}, {
              errorCode: _context21.t0.response.status,
              errorType: _context21.t0.response.data.error_type
            }));

          case 19:
            return _context21.abrupt("return", {
              success: false,
              errorCode: _context21.t0.response.status,
              errorType: _context21.t0.response.data.error_type
            });

          case 20:
            throw _context21.t0;

          case 21:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[3, 12]]);
  }));

  return function postReservationsUserInfo(_x51, _x52, _x53) {
    return _ref21.apply(this, arguments);
  };
}();
var postReservationsPayment = /*#__PURE__*/function () {
  var _ref22 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee22(args) {
    var reservationId, inputs, email, merchantPublicId, input, client, _yield$client$post4, data;

    return regenerator_default().wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            reservationId = args.reservationId, inputs = args.inputs, email = args.email, merchantPublicId = args.merchantPublicId;
            input = inputsToPostStructure(inputs, {
              email: email
            });
            _context22.prev = 2;
            client = (0,secured_axios/* newSecuredAxios */._R)({
              merchantPublicId: merchantPublicId
            });
            _context22.next = 6;
            return client.post("".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/payment/validate"), {
              input: input
            });

          case 6:
            _yield$client$post4 = _context22.sent;
            data = _yield$client$post4.data;
            return _context22.abrupt("return", {
              data: data
            });

          case 11:
            _context22.prev = 11;
            _context22.t0 = _context22["catch"](2);

            if (!(axios_default().isAxiosError(_context22.t0) && _context22.t0.response)) {
              _context22.next = 19;
              break;
            }

            if (!(_context22.t0.response.status === 400)) {
              _context22.next = 18;
              break;
            }

            return _context22.abrupt("return", {
              errorType: _context22.t0.response.data.error_type
            });

          case 18:
            return _context22.abrupt("return", {
              errorType: _context22.t0.response.data.error_type
            });

          case 19:
            throw _context22.t0;

          case 20:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[2, 11]]);
  }));

  return function postReservationsPayment(_x54) {
    return _ref22.apply(this, arguments);
  };
}();
var postReservationsFinish = /*#__PURE__*/function () {
  var _ref23 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee23(params) {
    var reservationId, inputs, lineAccessToken, merchantPublicId;
    return regenerator_default().wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            reservationId = params.reservationId, inputs = params.inputs, lineAccessToken = params.lineAccessToken, merchantPublicId = params.merchantPublicId;
            return _context23.abrupt("return", _postReservations("".concat((0,api/* apiRoot */.bI)(), "/reservations/").concat(reservationId, "/finalize"), {
              input: {
                terms_accepted: inputs.termsAccepted,
                payment_method: inputs.selectedPaymentMethod,
                line_access_token: lineAccessToken
              }
            }, merchantPublicId));

          case 2:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function postReservationsFinish(_x55) {
    return _ref23.apply(this, arguments);
  };
}();

var callStripeApi = function callStripeApi(payment, jcbEnabled) {
  return new Promise(function (resolve) {
    Stripe.createToken({
      cvc: payment.creditCard.securityCode,
      exp_month: parseInt(payment.creditCard.month, 10),
      exp_year: parseInt(payment.creditCard.year, 10),
      number: payment.creditCard.cardNumber
    }, function (status, response) {
      if (status === 200) {
        var brand = response.card.brand;

        if ((0,stripe/* isJCBBrand */.bw)(brand) && !jcbEnabled) {
          resolve({
            payment: payment,
            error: stripe/* invalidCardBrandError */.VP
          });
        } else {
          resolve({
            payment: _objectSpread(_objectSpread({}, payment), {}, {
              token: response.id
            })
          });
        }
      } else {
        resolve({
          payment: payment,
          error: response.error
        });
      }
    });
  });
};

var postPayment = /*#__PURE__*/function () {
  var _ref24 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee24(payment, jcbEnabled) {
    return regenerator_default().wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            if (!(payment.paymentMethod.method !== 'credit_card')) {
              _context24.next = 2;
              break;
            }

            return _context24.abrupt("return", {
              payment: payment
            });

          case 2:
            if (payment.cardSelection) {
              _context24.next = 4;
              break;
            }

            return _context24.abrupt("return", callStripeApi(payment, jcbEnabled));

          case 4:
            if (!(payment.cardSelection === 'used')) {
              _context24.next = 6;
              break;
            }

            return _context24.abrupt("return", {
              payment: payment
            });

          case 6:
            if (!(payment.cardSelection === 'another')) {
              _context24.next = 8;
              break;
            }

            return _context24.abrupt("return", callStripeApi(payment, jcbEnabled));

          case 8:
            throw new Error("cannot handle with payment: ".concat(payment));

          case 9:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function postPayment(_x56, _x57) {
    return _ref24.apply(this, arguments);
  };
}();

/***/ }),

/***/ 41189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getMerchantResourcesBooksInputs; }
/* harmony export */ });
var getMerchantResourcesBooksInputs = function getMerchantResourcesBooksInputs(state) {
  return state;
};

/***/ }),

/***/ 7788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h5": function() { return /* binding */ bookingEvent; },
/* harmony export */   "mG": function() { return /* binding */ purchaseEvent; }
/* harmony export */ });
/* unused harmony export GTM_CONFIGS */
var googleTagEnv = "production";
var GTM_CONFIGS = function () {
  switch (googleTagEnv) {
    case 'production':
      return {
        coubicFrontend: {
          auth: 'CXsKrbmeizWaaDt3OQhenA',
          containerId: 'GTM-MHRX774',
          preview: 'env-2'
        },
        coubicFrontend2: {
          auth: 'ppK0fcQWXybVZcdICBq2MA',
          containerId: 'GTM-WS64FTM',
          preview: 'env-2'
        }
      };

    case 'staging':
      return {
        coubicFrontendStaging: {
          auth: '60N0lrbFuaMSjWJtbZuzxw',
          containerId: 'GTM-PNBPHKZ',
          preview: 'env-2'
        },
        coubicFrontendStaging2: {
          auth: 'qj-_qgA8YLhy5RXC7R7BsA',
          containerId: 'GTM-TST7Z7M',
          preview: 'env-2'
        }
      };

    default:
      return {};
  }
}();
var bookingEvent = function bookingEvent(_ref) {
  var step = _ref.step,
      resourcePublicId = _ref.resourcePublicId,
      reservationPublicId = _ref.reservationPublicId;

  if (window.gtag) {
    window.gtag('event', 'booking_rendered', {
      booking_step: step,
      res_id: resourcePublicId,
      rv_id: reservationPublicId
    });
  }

  if (window.ga4tag) {
    var uri = new URL(window.location.href); // GA4 用のカスタムイベントのキー名称はマーチャントのオーナーが
    // アナリティクス管理の設定時に見ることのあるものなので、resourceという名前の露出を避けた名称にしています

    window.ga4tag('event', 'booking', {
      booking_step: step,
      reservation_page_id: resourcePublicId,
      reservation_id: reservationPublicId,
      URL: uri.href
    });
  }
};
var purchaseEvent = function purchaseEvent(_ref2) {
  var step = _ref2.step,
      productPublicId = _ref2.productPublicId,
      customerPublicId = _ref2.customerPublicId;

  if (window.gtag) {
    window.gtag('event', 'purchase_rendered', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId
    });
  }

  if (window.ga4tag) {
    var uri = new URL(window.location.href);
    window.ga4tag('event', 'purchase', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId,
      URL: uri.href
    });
  }
};

/***/ }),

/***/ 26246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VP": function() { return /* binding */ invalidCardBrandError; },
/* harmony export */   "bw": function() { return /* binding */ isJCBBrand; },
/* harmony export */   "h8": function() { return /* binding */ callStripeApi; }
/* harmony export */ });
var callStripeApi = function callStripeApi(creditCard, jcbEnabled) {
  return new Promise(function (resolve) {
    Stripe.createToken({
      cvc: creditCard.securityCode,
      exp_month: parseInt(creditCard.month, 10),
      exp_year: parseInt(creditCard.year, 10),
      number: creditCard.cardNumber
    }, function (status, response) {
      if (status === 200) {
        var brand = response.card.brand;

        if (isJCBBrand(brand) && !jcbEnabled) {
          resolve({
            error: invalidCardBrandError
          });
        } else {
          resolve({
            token: response.id
          });
        }
      } else {
        resolve({
          error: response.error
        });
      }
    });
  });
}; // JCBが使用できないマーチャントでJCBのカードが入力されたときにこのレスポンスを返す。
// 現状エラーメッセージの出しわけもstripeのレスポンスに依存しているので、stripeのレスポンスをハードコードしている。
// エラーレスポンスをラップしてメッセージを出し分けるように変更したい...

var invalidCardBrandError = {
  code: 'card_declined',
  decline_code: 'card_not_supported',
  doc_url: 'https://stripe.com/docs/error-codes/card-declined',
  message: 'Your card is not supported.',
  param: 'number',
  type: 'card_error'
};
var isJCBBrand = function isJCBBrand(brand) {
  var jcbBrands = ['JCB', 'Diners Club', 'Discover'];
  return jcbBrands.includes(brand);
};

/***/ }),

/***/ 67287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__HXmpr"};

/***/ })

}]);